import src from "IMAGE";
export default { src, width: 1405, height: 1151, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
